import styled, { css } from 'styled-components';
import Colors from '../../theme/Colors';

interface TabItemProps {
  active?: boolean;
}

interface ContainerProps {
  open?: boolean;
}

export const Container = styled.aside<ContainerProps>`
  width: 100%;
  max-width: 310px;
  background-color: ${Colors.primary};
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;

  position: absolute;
  top: 0px;
  bottom: 0;
  right: 0;
  padding: 12px;

  @media (max-width: 845px) {
    max-width: 0;
    padding: 0;
    display: none;

    ${props =>
      props.open &&
      css`
        max-width: 310px;
        padding: 12px;
        display: block;
        z-index: 99;
      `}
  }
`;

export const TabsContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 8px;

  display: flex;
  flex-direction: column;
`;

export const Tabs = styled.div`
  display: flex;
  justify-content: space-between;
  /* background-color: ${Colors.pink}; */
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  cursor: pointer;
`;

export const TabItem = styled.div<TabItemProps>`
  width: 100%;
  /* padding: 12px 8px; */
  color: #fff;
  text-align: center;
  font-weight: bold;
  font-size: 12px;

  ${props =>
    props.active &&
    css`
      background-color: #fff;
      color: ${Colors.grayDark};

      &:first-child {
        border-top-left-radius: 8px;
      }

      &:last-child {
        border-top-right-radius: 8px;
      }
    `}
`;

export const Overlay = styled.div<ContainerProps>`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(10px);
  z-index: 9;
  display: none;

  @media (max-width: 845px) {
    ${props =>
      props.open &&
      css`
        display: block;
      `}
  }
`;

export const CartFloatButton = styled.button`
  position: fixed;
  bottom: 16px;
  right: 16px;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  background-color: ${Colors.secondary};
  color: #fff;
  font-size: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  display: none;

  span {
    font-size: 12px;
    background-color: ${Colors.green};
    color: #fff;
    padding: 2px 6px;
    border-radius: 50%;
    font-weight: bold;
    position: absolute;
    top: 12px;
    right: 12px;
  }

  @media (max-width: 845px) {
    display: block;
  }
`;
